export const SharePercentFilterElements = [

  {
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "type",
    label: "روش محاسبه حق السهم",
    WrapperClassName: "!filterInput",
    options: "typeOption",
  },

]
